/**
 * CUÁNTAS PERSONAS, no cuántos hogares (Lissette, 2026-09-01):
 *
 *   "y a su vez poder filtrar ejemplo cantidad total de el cliente, cantidad
 *    total de conyugue y cantidad total de dependiente y cantidad total de
 *    todos juntos".
 *
 * El reporte cuenta FILAS, y una fila es un HOGAR: el titular, su cónyuge y
 * sus dependientes van todos en la misma. "340 resultados" puede ser 900
 * personas — y para una agencia de salud lo que se vende, se renueva y se
 * cobra es por PERSONA, no por hogar. Ese número no estaba en ninguna parte.
 *
 * POR QUÉ VIVE AQUÍ Y NO DENTRO DE LA PANTALLA: importar
 * `ReportsClientsView.jsx` arrastra `api.js` → `AuthGate.jsx` → MSAL, que
 * necesita `window`. Las pruebas corren en Node, así que probar esta cuenta
 * desde allí era imposible. Es la misma razón por la que `clientFilters.js`
 * está separado: la REGLA se prueba de verdad, sin montar React.
 */
export function totalesDePersonas(filas) {
  const vistos = new Set();
  let titulares = 0;
  let conyuges = 0;
  let dependientes = 0;

  for (const f of (filas || [])) {
    if (!f) continue;

    // Cada cliente se cuenta UNA vez. Hoy el reporte devuelve una fila por
    // cliente, pero si algún día devolviera una por PÓLIZA —quien tiene tres
    // pólizas saldría tres veces— contar personas por fila multiplicaría su
    // familia entera sin que nada en pantalla lo dijera.
    if (f.id) {
      if (vistos.has(f.id)) continue;
      vistos.add(f.id);
    }
    titulares += 1;

    // Cónyuge REGISTRADO en la ficha, no "estado civil = casado": hay fichas
    // casadas donde nunca se cargó al cónyuge, y contarlas inflaría el total
    // con gente que no existe en el CRM.
    const nombre = `${f.spouseFirstName || ''}${f.spouseLastName || ''}`.trim();
    if (nombre) conyuges += 1;

    // Un dato basura no puede envenenar el total: estos números salen a la
    // pantalla, y un NaN se contagia a la suma general — quedaría un reporte
    // enseñando "NaN personas".
    const deps = Number(f.dependentsCount);
    if (Number.isFinite(deps) && deps > 0) dependientes += deps;
  }

  return {
    titulares,
    conyuges,
    dependientes,
    personas: titulares + conyuges + dependientes,
  };
}
